import moment from "moment";

let daysAgo = {};
for (var i = 1; i <= 7; i++) {
  daysAgo[i] = moment().subtract(i, "days").format("YYYY-MM-DD");
}

////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
// TREEMAP

export const TreeMapDataSample = {
  Acura: {
    ILX: 11757,
    MDX: 54886,
    NSX: 581,
    RDX: 51295,
    RLX: 1237,
    TLX: 34846,
  },
  "Alfa Romeo": { "4C": 407, Giulia: 8903, Stelvio: 2721 },
  Audi: {
    A3: 20733,
    "A3 e-tron": 2877,
    A4: 37673,
    A5: 21301,
    A6: 16304,
    A7: 4810,
    A8: 3127,
    Q3: 20633,
    Q5: 57640,
    Q7: 38346,
    R8: 772,
    TT: 2294,
  },
  Bentley: {
    Bentayga: 1152,
    "Continental GT": 898,
    "Flying Spur": 257,
    Mulsanne: 98,
  },
  BMW: {
    "2-Series": 11737,
    "3-Series": 59449,
    "4-Series": 39634,
    "5-Series": 40658,
    "6-Series": 3355,
    "7-Series": 9276,
    i3: 6276,
    i8: 488,
    X1: 30826,
    X3: 40691,
    X4: 5198,
    X5: 50815,
    X6: 6780,
    Z4: 502,
  },
  Buick: {
    Cascada: 5595,
    Enclave: 48564,
    Encore: 88035,
    Envision: 41040,
    LaCrosse: 20161,
    Regal: 11559,
    Verano: 4277,
  },
  Cadillac: {
    ATS: 13100,
    CT6: 10542,
    CTS: 10344,
    ELR: 17,
    Escalade: 37694,
    SRX: 156,
    XT5: 68312,
    XTS: 16275,
  },
  Chevrolet: {
    Bolt: 23297,
    Camaro: 67940,
    "Caprice PPV": 693,
    "City Express": 8348,
    Colorado: 112996,
    Corvette: 25079,
    Cruze: 184751,
    Equinox: 290458,
    Express: 69164,
    Impala: 75877,
    Malibu: 185857,
    Silverado: 585864,
    Sonic: 30290,
    Spark: 22589,
    SS: 4055,
    Suburban: 56516,
    Tahoe: 98961,
    Traverse: 123506,
    Trax: 79289,
    Volt: 20349,
  },
  Chrysler: { 200: 18457, 300: 51237, Pacifica: 118274, "Town & Country": 577 },
  Dodge: {
    Avenger: 14,
    Challenger: 64537,
    Charger: 88351,
    Dart: 10082,
    Durango: 68761,
    "Grand Caravan": 125196,
    Journey: 89470,
    Viper: 585,
    "RAM P/U": 500723,
    "RAM ProMaster": 40483,
    "RAM ProMaster City": 15584,
  },
  Fiat: { "124 Spider": 4478, 500: 12685, "500L": 1664, "500X": 7665 },
  Ford: {
    "C-Max": 18390,
    Edge: 142603,
    Escape: 308296,
    "E-Series": 53304,
    Expedition: 51883,
    Explorer: 271131,
    Fiesta: 46249,
    Flex: 22389,
    Focus: 158385,
    "F-Series": 896764,
    Fusion: 209623,
    GT: 89,
    Mustang: 81866,
    Taurus: 41236,
    Transit: 127360,
    "Transit Connect": 34473,
  },
  Genesis: { G80: 16196, G90: 4398 },
  GMC: {
    Acadia: 111276,
    Canyon: 32106,
    Savana: 29679,
    Sierra: 217943,
    Terrain: 85441,
    Yukon: 49183,
    "Yukon XL": 35059,
  },
  Honda: {
    Accord: 322655,
    Civic: 377286,
    "Clarity FCV": 2455,
    Crosstour: 5,
    "CR-V": 377895,
    "CR-Z": 705,
    Fit: 49454,
    "HR-V": 94034,
    Insight: 3,
    Odyssey: 100307,
    Pilot: 127279,
    Ridgeline: 34749,
  },
  Hyundai: {
    Accent: 58955,
    Azera: 3060,
    Elantra: 198210,
    Equus: 20,
    Genesis: 1152,
    Ioniq: 11197,
    "Santa Fe": 133171,
    Sonata: 131803,
    Tucson: 114735,
    Veloster: 12658,
  },
  Infiniti: {
    Q50: 40739,
    Q60: 10751,
    Q70: 5772,
    QX30: 14093,
    QX50: 16857,
    QX60: 40444,
    QX70: 6878,
    QX80: 17881,
  },
  Jaguar: { "F-Pace": 18946, "F-Type": 4108, XE: 9278, XF: 4541, XJ: 2721 },
  Jeep: {
    Cherokee: 169882,
    Compass: 83253,
    "Grand Cherokee": 240696,
    Patriot: 10735,
    Renegade: 103434,
    Wrangler: 190522,
  },
  Kia: {
    Cadenza: 7249,
    Forte: 117596,
    K900: 455,
    Niro: 27237,
    Optima: 107493,
    Rio: 16760,
    Sedona: 23815,
    Sorento: 99684,
    Soul: 115712,
    Sportage: 72824,
    Stinger: 843,
  },
  "Land Rover": {
    "Discovery / LR4": 6398,
    "Discovery Sport": 14187,
    "Range Rover": 16869,
    "Range Rover Evoque": 11979,
    "Range Rover Sport": 19153,
    "Range Rover Velar": 6153,
  },
  Lexus: {
    CT: 4690,
    ES: 51398,
    GS: 7773,
    GX: 27190,
    IS: 26482,
    LC: 2487,
    LFA: 3,
    LS: 4094,
    LX: 6004,
    NX: 59341,
    RC: 7363,
    RX: 108307,
  },
  Lincoln: {
    Continental: 12012,
    MKC: 27048,
    MKS: 153,
    MKT: 3005,
    MKX: 31031,
    MKZ: 27387,
    Navigator: 10523,
  },
  Maserati: {
    Ghibli: 5531,
    GranTurismo: 1018,
    Levante: 5448,
    Quattroporte: 1700,
  },
  Mazda: {
    3: 75018,
    5: 10,
    6: 33402,
    "CX-3": 16355,
    "CX-5": 127563,
    "CX-9": 25828,
    "MX-5 Miata": 11294,
  },
  "Mercedes-Benz": {
    "B-Class": 744,
    "C-Class": 77447,
    "CLA-Class": 20669,
    "E / CLS-Class": 51312,
    "G-Class": 4188,
    "GLA-Class": 24104,
    "GLC-Class": 48643,
    "GLE-Class": 54595,
    "GLS-Class": 32248,
    Metris: 7579,
    "S-Class": 15888,
    "SLC-Class": 2860,
    "SL-Class": 2940,
    Sprinter: 27415,
  },
  Mini: { Cooper: 32232, Countryman: 14864, Paceman: 9 },
  Mitsubishi: {
    "i MiEV": 6,
    Lancer: 12725,
    Mirage: 22386,
    Outlander: 35310,
    "Outlander PHEV": 99,
    "Outlander Sport": 33160,
  },
  Nissan: {
    "370Z": 4614,
    Altima: 254996,
    Armada: 35667,
    Frontier: 74360,
    "GT-R": 578,
    Juke: 10157,
    Leaf: 11230,
    Maxima: 67627,
    Murano: 76732,
    NV: 17858,
    NV200: 18602,
    Pathfinder: 81065,
    Quest: 4950,
    Rogue: 403465,
    Sentra: 218451,
    Titan: 52924,
    Versa: 106772,
    Xterra: 1,
  },
  Porsche: {
    911: 8970,
    Boxster: 2287,
    Cayenne: 13203,
    Cayman: 2800,
    Macan: 21429,
    Panamera: 6431,
  },
  Smart: { Fortwo: 3071 },
  Subaru: {
    BRZ: 4131,
    Crosstrek: 110138,
    Forester: 177563,
    Impreza: 117401,
    Legacy: 49837,
    Outback: 188886,
  },
  Tesla: { "Model 3": 2320, "Model S †": 28800, "Model X †": 24000 },
  Toyota: {
    "4Runner": 128296,
    "86/Scion FR-S": 6846,
    Avalon: 32583,
    Camry: 387081,
    "C-HR": 25755,
    Corolla: 329196,
    "FJ Cruiser": 4,
    Highlander: 215775,
    "Land Cruiser": 3100,
    Mirai: 1838,
    Prius: 108662,
    RAV4: 407594,
    Sequoia: 12156,
    Sienna: 111489,
    Tacoma: 198124,
    Tundra: 116285,
    Venza: 14,
    Yaris: 44380,
  },
  Volkswagen: {
    Atlas: 27119,
    Beetle: 15166,
    CC: 1355,
    Eos: 1,
    Golf: 68978,
    Jetta: 115807,
    Passat: 60722,
    Tiguan: 46983,
    Touareg: 3545,
  },
  Volvo: { S60: 16825, S80: 7, S90: 11090, XC60: 22516, XC90: 30996 },
};

export const SimpleTreeMapDataSample1 = [
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Comedy",
    value: 10.656007,
    value2: 10.656007,
    value3: 0.0,
    level: 1,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Ent",
    value: 0.113627,
    value2: 0.113627,
    value3: 0.0,
    level: 1,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "GEC",
    value: 933.667589,
    value2: 933.667589,
    value3: 0.0,
    level: 1,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Infotainment",
    value: 3.551476,
    value2: 3.551476,
    value3: 0.0,
    level: 1,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Lifestyle",
    value: 0.905006,
    value2: 0.905006,
    value3: 0.0,
    level: 1,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Movies",
    value: 469.966183,
    value2: 469.966183,
    value3: 0.0,
    level: 1,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Music",
    value: 79.059551,
    value2: 79.059551,
    value3: 0.0,
    level: 1,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "News",
    value: 96.645284,
    value2: 96.645284,
    value3: 0.0,
    level: 1,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Sports",
    value: 212.876086,
    value2: 212.876086,
    value3: 0.0,
    level: 1,
  },
];

export const SimpleTreeMapDataSample = [
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Comedy",
    category: "Comedy",
    value: 10.656007,
    grp: 10.656007,
    spend: 0.0,
    level: 2,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Ent",
    category: "Ent",
    value: 0.113627,
    grp: 0.113627,
    spend: 0.0,
    level: 2,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "GEC",
    category: "GEC",
    value: 933.667589,
    grp: 933.667589,
    spend: 0.0,
    level: 2,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Infotainment",
    category: "Infotainment",
    value: 3.551476,
    grp: 3.551476,
    spend: 0.0,
    level: 2,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Lifestyle",
    category: "Lifestyle",
    value: 0.905006,
    grp: 0.905006,
    spend: 0.0,
    level: 2,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Movies",
    category: "Movies",
    value: 469.966183,
    grp: 469.966183,
    spend: 0.0,
    level: 2,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Music",
    category: "Music",
    value: 79.059551,
    grp: 79.059551,
    spend: 0.0,
    level: 2,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "News",
    category: "News",
    value: 96.645284,
    grp: 96.645284,
    spend: 0.0,
    level: 2,
  },
  {
    brand_id: "4e41ef77-70e7-4444-aff1-282011b1278f",
    brand_name: "APPY FIZZ",
    name: "Sports",
    category: "Sports",
    value: 212.876086,
    grp: 212.876086,
    spend: 0.0,
    level: 2,
  },
];

////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
// SOLID GAUGE

export const SolidGaugeDataSample = [
  {
    label: "State",
    value: 80,
  },
  {
    label: "Zone",
    value: 35,
  },
  {
    label: "Overall",
    value: 92,
  }
];

////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
// WORDCLOUD
export const WordCloudDataSample =
  "Though yet of Hamlet our dear brother's death The memory be green, and that it us befitted To bear our hearts in grief and our whole kingdom To be contracted in one brow of woe, Yet so far hath discretion fought with nature That we with wisest sorrow think on him, Together with remembrance of ourselves. Therefore our sometime sister, now our queen, The imperial jointress to this warlike state, Have we, as 'twere with a defeated joy,-- With an auspicious and a dropping eye, With mirth in funeral and with dirge in marriage, In equal scale weighing delight and dole,-- Taken to wife: nor have we herein barr'd Your better wisdoms, which have freely gone With this affair along. For all, our thanks. Now follows, that you know, young Fortinbras, Holding a weak supposal of our worth, Or thinking by our late dear brother's death Our state to be disjoint and out of frame, Colleagued with the dream of his advantage, He hath not fail'd to pester us with message, Importing the surrender of those lands Lost by his father, with all bonds of law, To our most valiant brother. So much for him. Now for ourself and for this time of meeting: Thus much the business is: we have here writ To Norway, uncle of young Fortinbras,-- Who, impotent and bed-rid, scarcely hears Of this his nephew's purpose,--to suppress His further gait herein; in that the levies, The lists and full proportions, are all made Out of his subject: and we here dispatch You, good Cornelius, and you, Voltimand, For bearers of this greeting to old Norway; Giving to you no further personal power To business with the king, more than the scope Of these delated articles allow. Farewell, and let your haste commend your duty. Tis sweet and commendable in your nature, Hamlet,To give these mourning duties to your father: But, you must know, your father lost a father; That father lost, lost his, and the survivor bound In filial obligation for some term To do obsequious sorrow: but to persever In obstinate condolement is a course Of impious stubbornness; 'tis unmanly grief; It shows a will most incorrect to heaven, A heart unfortified, a mind impatient, An understanding simple and unschool'd: For what we know must be and is as common As any the most vulgar thing to sense, Why should we in our peevish opposition Take it to heart? Fie! 'tis a fault to heaven, A fault against the dead, a fault to nature, To reason most absurd: whose common theme Is death of fathers, and who still hath cried, From the first corse till he that died to-day, 'This must be so.' We pray you, throw to earth This unprevailing woe, and think of us As of a father: for let the world take note, You are the most immediate to our throne; And with no less nobility of love Than that which dearest father bears his son, Do I impart toward you. For your intent In going back to school in Wittenberg, It is most retrograde to our desire: And we beseech you, bend you to remain Here, in the cheer and comfort of our eye, Our chiefest courtier, cousin, and our son.";

///////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
// MULTIAXIS BAR CHART
export const MultiAxisBarDataSample = [
  {
    label: 2019,
    value1: 3.5,
    value2: 0.9,
  },
  {
    label: 2020,
    value1: 2.5,
    value2: 0.4,
  },
  {
    label: 2021,
    value1: 5.5,
    value2: 0.7,
  },
];
export const MultiAxisBarDataLabelsSample = [
  {
    label: "Current",
    value: "value1",
  },
  {
    label: "Previous",
    value: "value2",
  },
];

////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
// LINECHART
export const LineChartDataSample = [
  {
    label: daysAgo[7],
    value: 1587,
  },
  {
    label: daysAgo[6],
    value: 1567,
  },
  {
    label: daysAgo[5],
    value: 1617,
  },
  {
    label: daysAgo[4],
    value: 1630,
  },
  {
    label: daysAgo[3],
    value: 1660,
  },
  {
    label: daysAgo[2],
    value: 1683,
  },
  {
    label: daysAgo[1],
    value: 1691,
  },
];
export const LineChartDataLabelsSample = [
  {
    label: "label",
    value: "value",
  },
];
export const LineCharTargetSample = [
  {
    value: 1650,
  },
];


// SINGLE LINE CHART EXTRA DATA
export const LineChartExtraDataSample = [
  {
    label: daysAgo[7],
    value: 1587,
    totalsold: 785,
  },
  {
    label: daysAgo[6],
    value: 1567,
    totalsold: 658,
  },
  {
    label: daysAgo[5],
    value: 1617,
    totalsold: 985,
  },
  {
    label: daysAgo[4],
    value: 1630,
    totalsold: 745,
  },
  {
    label: daysAgo[3],
    value: 1660,
    totalsold: 125,
  },
  {
    label: daysAgo[2],
    value: 1683,
    totalsold: 755,
  },
  {
    label: daysAgo[1],
    value: 1691,
    totalsold: 785,
  },
];
export const LineChartExtraDataLabelsSample = [
  {
    label: "Cars",
    value: "value",
    childLabel: "Total Sold",
    childValue: "totalsold",
  },
];

// COMPARE LINE / TWO LINES DATA SAMPLE
export const TwoLineChartDataSample = [
  {
    label: daysAgo[7],
    value1: 889,
    value2: 934,
  },
  {
    label: daysAgo[6],
    value1: 843,
    value2: 883,
  },
  {
    label: daysAgo[5],
    value1: 800,
    value2: 915,
  },
  {
    label: daysAgo[4],
    value1: 999,
    value2: 887,
  },
  {
    label: daysAgo[3],
    value1: 965,
    value2: 912,
  },
  {
    label: daysAgo[2],
    value1: 926,
    value2: 920,
  },
  {
    label: daysAgo[1],
    value1: 851,
    value2: 834,
  },
];
export const TwoLineChartDataLabelsSample = [
  {
    label: "Current",
    value: "value1",
  },
  {
    label: "Previous",
    value: "value2",
  },
];

// FOUR LINES DATA SAMPLE
export const ThreeLineChartDataSample = [
  {
    label: daysAgo[7],
    value1: 875,
    value2: 812,
    value3: 924,
  },
  {
    label: daysAgo[6],
    value1: 817,
    value2: 978,
    value3: 962,
  },
  {
    label: daysAgo[5],
    value1: 981,
    value2: 951,
    value3: 820,
  },
  {
    label: daysAgo[4],
    value1: 923,
    value2: 806,
    value3: 909,
  },
  {
    label: daysAgo[3],
    value1: 814,
    value2: 830,
    value3: 991,
  },
  {
    label: daysAgo[2],
    value1: 972,
    value2: 828,
    value3: 999,
  },
  {
    label: daysAgo[1],
    value1: 814,
    value2: 884,
    value3: 913,
  },
];
export const ThreeLineChartDataLabelsSample = [
  {
    label: "label1",
    value: "value1",
  },
  {
    label: "label2",
    value: "value2",
  },
  {
    label: "label3",
    value: "value3",
  },
];

// FOUR LINES DATA SAMPLE
export const FourLineChartDataSample = [
  {
    label: daysAgo[7],
    value1: 875,
    value2: 812,
    value3: 924,
    value4: 934,
  },
  {
    label: daysAgo[6],
    value1: 817,
    value2: 978,
    value3: 962,
    value4: 873,
  },
  {
    label: daysAgo[5],
    value1: 981,
    value2: 951,
    value3: 820,
    value4: 910,
  },
  {
    label: daysAgo[4],
    value1: 923,
    value2: 806,
    value3: 909,
    value4: 849,
  },
  {
    label: daysAgo[3],
    value1: 814,
    value2: 830,
    value3: 991,
    value4: 835,
  },
  {
    label: daysAgo[2],
    value1: 972,
    value2: 828,
    value3: 999,
    value4: 1000,
  },
  {
    label: daysAgo[1],
    value1: 814,
    value2: 884,
    value3: 913,
    value4: 805,
  },
];
export const FourLineChartDataLabelsSample = [
  {
    label: "label1",
    value: "value1",
  },
  {
    label: "label2",
    value: "value2",
  },
  {
    label: "label3",
    value: "value3",
  },
  {
    label: "label4",
    value: "value4",
  },
];

// FIVE LINES DATA SAMPLE
export const FiveLineChartDataSample = [
  {
    label: daysAgo[7],
    value1: 875,
    value2: 812,
    value3: 924,
    value4: 934,
    value5: 939,
  },
  {
    label: daysAgo[6],
    value1: 817,
    value2: 978,
    value3: 962,
    value4: 873,
    value5: 947,
  },
  {
    label: daysAgo[5],
    value1: 981,
    value2: 951,
    value3: 820,
    value4: 910,
    value5: 946,
  },
  {
    label: daysAgo[4],
    value1: 923,
    value2: 806,
    value3: 909,
    value4: 849,
    value5: 961,
  },
  {
    label: daysAgo[3],
    value1: 814,
    value2: 830,
    value3: 991,
    value4: 835,
    value5: 984,
  },
  {
    label: daysAgo[2],
    value1: 972,
    value2: 828,
    value3: 999,
    value4: 1000,
    value5: 943,
  },
  {
    label: daysAgo[1],
    value1: 814,
    value2: 884,
    value3: 913,
    value4: 805,
    value5: 921,
  },
];
export const FiveLineChartDataLabelsSample = [
  {
    label: "label1",
    value: "value1",
  },
  {
    label: "label2",
    value: "value2",
  },
  {
    label: "label3",
    value: "value3",
  },
  {
    label: "label4",
    value: "value4",
  },
  {
    label: "label5",
    value: "value5",
  },
];

// MULTI LINE CHART EXTRA DATA
export const MultiLineChartExtraDataSample = [
  {
    label: daysAgo[7],
    value1: 1587,
    value2: 1354,
    value3: 121,
    totalsoldvalue1: 785,
    totalsoldvalue2: 685,
    totalsoldvalue3: 585,
  },
  {
    label: daysAgo[6],
    value1: 1567,
    value2: 1423,
    value3: 146,
    totalsoldvalue1: 182,
    totalsoldvalue2: 282,
    totalsoldvalue3: 382,
  },
  {
    label: daysAgo[5],
    value1: 1617,
    value2: 1517,
    value3: 138,
    totalsoldvalue1: 185,
    totalsoldvalue2: 285,
    totalsoldvalue3: 385,
  },
  {
    label: daysAgo[4],
    value1: 1630,
    value2: 1530,
    value3: 127,
    totalsoldvalue1: 145,
    totalsoldvalue2: 245,
    totalsoldvalue3: 345,
  },
  {
    label: daysAgo[3],
    value1: 1660,
    value2: 1560,
    value3: 105,
    totalsoldvalue1: 145,
    totalsoldvalue2: 245,
    totalsoldvalue3: 345,
  },
  {
    label: daysAgo[2],
    value1: 1683,
    value2: 1683,
    value3: 109,
    totalsoldvalue1: 185,
    totalsoldvalue2: 285,
    totalsoldvalue3: 385,
  },
  {
    label: daysAgo[1],
    value1: 1691,
    value2: 1692,
    value3: 112,
    totalsoldvalue1: 1250,
    totalsoldvalue2: 2250,
    totalsoldvalue3: 3250,
  },
];
export const MultiLineChartExtraDataLabelsSample = [
  {
    label: "Cars",
    value: "value1",
    childLabel: "Total Cars Sold",
    childValue: "totalsoldvalue1",
  },
  {
    label: "Motor Cycles",
    value: "value2",
    childLabel: "Total Motor Cycles Sold",
    childValue: "totalsoldvalue2",
  },
];

// MULTIPLE VALUE AXES LINECHART
export const MultipleValueAxesLineChartDataSample = [
  [
    {
      label: daysAgo[7],
      value: 104,
    },
    {
      label: daysAgo[6],
      value: 105,
    },
    {
      label: daysAgo[5],
      value: 107,
    },
    {
      label: daysAgo[4],
      value: 110,
    },
    {
      label: daysAgo[3],
      value: 114,
    },
    {
      label: daysAgo[2],
      value: 120,
    },
    {
      label: daysAgo[1],
      value: 116,
    },
  ],
  [
    {
      label: daysAgo[7],
      value: 1016,
    },
    {
      label: daysAgo[6],
      value: 984,
    },
    {
      label: daysAgo[5],
      value: 967,
    },
    {
      label: daysAgo[4],
      value: 950,
    },
    {
      label: daysAgo[3],
      value: 956,
    },
    {
      label: daysAgo[2],
      value: 964,
    },
    {
      label: daysAgo[1],
      value: 946,
    },
  ],
  [
    {
      label: daysAgo[7],
      value: 8195,
    },
    {
      label: daysAgo[6],
      value: 8359,
    },
    {
      label: daysAgo[5],
      value: 8530,
    },
    {
      label: daysAgo[4],
      value: 8293,
    },
    {
      label: daysAgo[3],
      value: 8135,
    },
    {
      label: daysAgo[2],
      value: 8062,
    },
    {
      label: daysAgo[1],
      value: 8390,
    },
  ],
];
export const MultipleValueAxesLineChartDataLabelsSample = [
  {
    label: "Organic",
    value: "value",
    opposite: false,
  },
  {
    label: "Paid",
    value: "value",
    opposite: true,
  },
  {
    label: "Difference",
    value: "value",
    opposite: true,
  },
];

////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
// BARCHART
export const BarChartDataSample = [
  {
    label: daysAgo[7],
    value: 1587,
  },
  {
    label: daysAgo[6],
    value: 1567,
  },
  {
    label: daysAgo[5],
    value: 1617,
  },
  {
    label: daysAgo[4],
    value: 1630,
  },
  {
    label: daysAgo[3],
    value: 1660,
  },
  {
    label: daysAgo[2],
    value: 1683,
  },
  {
    label: daysAgo[1],
    value: 1691,
  },
];
export const BarChartDataLabelssample = [
  {
    label: "label",
    value: "value",
  },
];

// SINGLE LINE CHART EXTRA DATA
export const BarChartExtraDataSample = [
  {
    label: daysAgo[7],
    value: 1587,
    totalsold: 785,
  },
  {
    label: daysAgo[6],
    value: 1567,
    totalsold: 658,
  },
  {
    label: daysAgo[5],
    value: 1617,
    totalsold: 985,
  },
  {
    label: daysAgo[4],
    value: 1630,
    totalsold: 745,
  },
  {
    label: daysAgo[3],
    value: 1660,
    totalsold: 125,
  },
  {
    label: daysAgo[2],
    value: 1683,
    totalsold: 755,
  },
  {
    label: daysAgo[1],
    value: 1691,
    totalsold: 785,
  },
];
export const BarChartExtraDataLabelsSample = [
  {
    label: "Cars",
    value: "value",
    childLabel: "Total Sold",
    childValue: "totalsold",
  },
];

// TWO BARS DATA SAMPLE
export const TwoBarChartDataSample = [
  {
    label: daysAgo[7],
    value1: 1587,
    value2: 1354,
  },
  {
    label: daysAgo[6],
    value1: 1567,
    value2: 1423,
  },
  {
    label: daysAgo[5],
    value1: 1617,
    value2: 1517,
  },
  {
    label: daysAgo[4],
    value1: 1630,
    value2: 1530,
  },
  {
    label: daysAgo[3],
    value1: 1660,
    value2: 1560,
  },
  {
    label: daysAgo[2],
    value1: 1683,
    value2: 1683,
  },
  {
    label: daysAgo[1],
    value1: 1691,
    value2: 1692,
  },
];
export const TwoBarChartDataLabelssample = [
  {
    label: "label1",
    value: "value1",
  },
  {
    label: "label2",
    value: "value2",
  },
];

// MULTIPLE BARS DATA SAMPLE
export const MultiBarChartDataSample = [
  {
    label: daysAgo[7],
    value: 1587,
    value2: 1354,
    value3: 1587,
    value4: 1354,
  },
  {
    label: daysAgo[6],
    value: 1567,
    value2: 1423,
    value3: 1567,
    value4: 1423,
  },
  {
    label: daysAgo[5],
    value: 1617,
    value2: 1517,
    value3: 1617,
    value4: 1517,
  },
  {
    label: daysAgo[4],
    value: 1630,
    value2: 1530,
    value3: 1630,
    value4: 1530,
  },
  {
    label: daysAgo[3],
    value: 1660,
    value2: 1560,
    value3: 1660,
    value4: 1560,
  },
  {
    label: daysAgo[2],
    value: 1683,
    value2: 1683,
    value3: 1683,
    value4: 1683,
  },
  {
    label: daysAgo[1],
    value: 1691,
    value2: 1692,
    value3: 1691,
    value4: 1692,
  },
];
export const MultiBarChartDataLabelssample = [
  {
    label: "label1",
    value: "value",
  },
  {
    label: "label2",
    value: "value2",
  },
  {
    label: "label3",
    value: "value3",
  },
  {
    label: "label2",
    value: "value4",
  },
];

// MULTI LINE CHART EXTRA DATA
export const MultiBarChartExtraDataSample = [
  {
    label: daysAgo[7],
    value1: 1587,
    value2: 1354,
    value3: 121,
    totalsoldvalue1: 785,
    totalsoldvalue2: 685,
    totalsoldvalue3: 585,
  },
  {
    label: daysAgo[6],
    value1: 1567,
    value2: 1423,
    value3: 146,
    totalsoldvalue1: 182,
    totalsoldvalue2: 282,
    totalsoldvalue3: 382,
  },
  {
    label: daysAgo[5],
    value1: 1617,
    value2: 1517,
    value3: 138,
    totalsoldvalue1: 185,
    totalsoldvalue2: 285,
    totalsoldvalue3: 385,
  },
  {
    label: daysAgo[4],
    value1: 1630,
    value2: 1530,
    value3: 127,
    totalsoldvalue1: 145,
    totalsoldvalue2: 245,
    totalsoldvalue3: 345,
  },
  {
    label: daysAgo[3],
    value1: 1660,
    value2: 1560,
    value3: 105,
    totalsoldvalue1: 145,
    totalsoldvalue2: 245,
    totalsoldvalue3: 345,
  },
  {
    label: daysAgo[2],
    value1: 1683,
    value2: 1683,
    value3: 109,
    totalsoldvalue1: 185,
    totalsoldvalue2: 285,
    totalsoldvalue3: 385,
  },
  {
    label: daysAgo[1],
    value1: 1691,
    value2: 1692,
    value3: 112,
    totalsoldvalue1: 1250,
    totalsoldvalue2: 2250,
    totalsoldvalue3: 3250,
  },
];
export const MultiBarChartExtraDataLabelsSample = [
  {
    label: "Cars",
    value: "value1",
    childLabel: "Total Cars Sold",
    childValue: "totalsoldvalue1",
  },
  {
    label: "Motor Cycles",
    value: "value2",
    childLabel: "Total Motor Cycles Sold",
    childValue: "totalsoldvalue2",
  },
];

// POSITIVE NEGATIVE DATA SAMPLE
export const PositiveNegativeBarChartDataSample = [
  {
    label: daysAgo[7],
    value1: 1587,
    value2: -1354,
  },
  {
    label: daysAgo[6],
    value1: 1567,
    value2: -1423,
  },
  {
    label: daysAgo[5],
    value1: 1617,
    value2: -1517,
  },
  {
    label: daysAgo[4],
    value1: 1630,
    value2: -1530,
  },
  {
    label: daysAgo[3],
    value1: 1660,
    value2: -1560,
  },
  {
    label: daysAgo[2],
    value1: 1683,
    value2: -1683,
  },
  {
    label: daysAgo[1],
    value1: 1691,
    value2: -1692,
  },
];
export const PositiveNegativeBarChartDataLabelssample = [
  {
    label: "label1",
    value: "value1",
  },
  {
    label: "label2",
    value: "value2",
  },
];

// STACKED COLUMN CHART DATA SAMPLE
export const StackedColumnChartDataSample = [
  {
    label: "Like",
    value1: 2.5,
    value2: 2.5,
    value3: 2.1,
    value4: 1,
    value5: 0.8,
    value6: 0.4,
  },
  {
    label: "Unlike",
    value1: 2.6,
    value2: 2.7,
    value3: 2.2,
    value4: 0.5,
    value5: 0.4,
    value6: 0.3,
  },
];
export const StackedColumnChartDataLabelsSample = [
  {
    label: "Ads",
    value: "value1",
  },
  {
    label: "News Feed",
    value: "value2",
  },
  {
    label: "Page Suggestions ",
    value: "value3",
  },
  {
    label: "Requests",
    value: "value4",
  },
  {
    label: "Re-activated accouts",
    value: "value5",
  },
  {
    label: "By Search",
    value: "value6",
  },
];

// SIX
export const SixStackedColumnChartDataSample = [
  {
    label: "Impressions",
    value1: 2.5,
    value2: 2.5,
    value3: 2.1,
    value4: 1,
    value5: 0.8,
  },
  {
    label: "Clicks",
    value1: 2.6,
    value2: 2.7,
    value3: 2.2,
    value4: 0.5,
    value5: 0.4,
  },
  {
    label: "Spends",
    value1: 2.6,
    value2: 2.7,
    value3: 2.2,
    value4: 0.5,
    value5: 0.4,
  },
  {
    label: "Leads",
    value1: 2.6,
    value2: 2.7,
    value3: 2.2,
    value4: 0.5,
    value5: 0.4,
  },
  {
    label: "RPC",
    value1: 2.6,
    value2: 2.7,
    value3: 2.2,
    value4: 0.5,
    value5: 0.4,
  },
  {
    label: "Conversion",
    value1: 2.6,
    value2: 2.7,
    value3: 2.2,
    value4: 0.5,
    value5: 0.4,
  },
];
export const SixStackedColumnChartDataLabelsSample = [
  {
    label: "Google",
    value: "value1",
  },
  {
    label: "Facebook",
    value: "value2",
  },
  {
    label: "Instagram",
    value: "value3",
  },
  {
    label: "Twitter",
    value: "value4",
  },
  {
    label: "Linkedin",
    value: "value5",
  },
];

////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
// COMBINE BAR & LINE MIX CHART

export const CombinedBarLineMultipleAxesChartDataSample = [
  {
    label: daysAgo[7],
    value1: 71,
    value2: 5,
    value3: 9,
    value4: 7,
  },
  {
    label: daysAgo[6],
    value1: 74,
    value2: 4,
    value3: 6,
    value4: 7,
  },
  {
    label: daysAgo[5],
    value1: 78,
    value2: 5,
    value3: 2,
    value4: 7,
  },
  {
    label: daysAgo[4],
    value1: 85,
    value2: 8,
    value3: 9,
    value4: 7,
  },
  {
    label: daysAgo[3],
    value1: 82,
    value2: 9,
    value3: 6,
    value4: 7,
  },
  {
    label: daysAgo[2],
    value1: 83,
    value2: 3,
    value3: 5,
    value4: 7,
  },
  {
    label: daysAgo[1],
    value1: 88,
    value2: 5,
    value3: 7,
    value4: 7,
  },
];
export const CombinedBarLineMultipleAxesChartDataLabelsSample = [
  {
    barchartLabels: [
      {
        label: "label1",
        value: "value1",
      },
      {
        label: "label2",
        value: "value2",
      },
    ],
    linechartLabels: [
      {
        label: "label3",
        value: "value3",
      },
      {
        label: "label4",
        value: "value4",
      },
    ],
  },
];

// export const CombinedBarLineMultipleAxesChartDataSample = [
//   {
//     label: "2022-11-13",
//     total_views: 6789.0,
//     engagement_rate: 0.01885402857563706,
//     total_no_of_videos: 3.0,
//     video_completion_rate: 275.0,
//   },
//   {
//     label: "2022-11-15",
//     total_views: 2370.0,
//     engagement_rate: 0.021940928270042195,
//     total_no_of_videos: 4.0,
//     video_completion_rate: 54.0,
//   },
// ];

// export const CombinedBarLineMultipleAxesChartDataLabelsSample = [
//   {
//     linechartLabels: [
//       {
//         label: "Total Views",
//         value: "total_views",
//       },
//       {
//         label: "Total no of videos",
//         value: "total_no_of_videos",
//       },
//     ],
//     barchartLabels: [
//       {
//         label: "Engagement Rate",
//         value: "engagement_rate",
//       },
//       {
//         label: "Video Completion Rate",
//         value: "video_completion_rate",
//       },
//     ],
//   },
// ];

////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
// DONUT CHART
export const DonutPieChartDataSample = [
  { value: 100000000, label: "One" },
  { value: 2222222222222, label: "Two" },
  { value: 678974858785487845, label: "Three" },
  { value: 512154587878454878, label: "Four" },
  { value: 47897488784545, label: "Five" },
  { value: 3787878, label: "Six" },
  { value: 1, label: "Seven" },
];

export const DonutPieChartExtraDataSample = [
  {
    label: "Desktop",
    value: 112,
    childLabel: "Desktop Avg",
    childValue: 3.8620689655172415,
  },
  {
    label: "Mobile",
    value: 171,
    childLabel: "Mobile Avg",
    childValue: 5.896551724137931,
  },
];

////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
// PIE OF PIE
export const PieofaPieChartDataSample = [
  {
    label: "Photo",
    value: 45515,
    subData: [
      {
        label: "Comments",
        value: 65,
      },
      {
        label: "Reactions",
        value: 33685,
      },
      {
        label: "Shares",
        value: 230,
      },
      {
        label: "Clicks",
        value: 11535,
      },
    ],
  },
  {
    label: "Album",
    value: 187180,
    subData: [
      {
        label: "Comments",
        value: 28,
      },
      {
        label: "Reactions",
        value: 7548,
      },
      {
        label: "Shares",
        value: 1064,
      },
      {
        label: "Clicks",
        value: 178540,
      },
    ],
  },
  {
    label: "Video",
    value: 1092678,
    subData: [
      {
        label: "Comments",
        value: 214,
      },
      {
        label: "Reactions",
        value: 13307,
      },
      {
        label: "Shares",
        value: 3994,
      },
      {
        label: "Clicks",
        value: 1075163,
      },
    ],
  },
];

export const PieofaPieChartDataLabelSample = [
  {
    label: "Comments",
    value: 0,
  },
  {
    label: "Reactions",
    value: 0,
  },
  {
    label: "Shares",
    value: 0,
  },
  {
    label: "Clicks",
    value: 0,
  },
];

////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
// SANKEY CHART

export const SankeyChartSampleData = [
  { from: "Google", to: "Brand Awareness", value: 10 },
  { from: "Google", to: "Sales", value: 10 },
  { from: "Google", to: "Leads", value: 10 },
  { from: "Google", to: "Website Traffic", value: 10 },
  { from: "Facebook", to: "Brand Awareness", value: 10 },
  { from: "Facebook", to: "Sales", value: 10 },
  { from: "Instagram", to: "Leads", value: 10 },
  { from: "Twitter", to: "Website Traffic", value: 10 },
  { from: "Twitter", to: "Reach", value: 8 },
  { from: "Linkedin", to: "Brand Awareness", value: 4 },
  { from: "Linkedin", to: "Reach", value: 3 },
  { from: "Linkedin", to: "Leads", value: 5 },
  { from: "Brand Awareness", to: "Share a coke", value: 10 },
  { from: "Sales", to: "Share a coke", value: 10 },
  { from: "Website Traffic", to: "Taste the Feeling", value: 10 },
  { from: "Leads", to: "Taste the Feeling", value: 10 },
  { from: "Reach", to: "Taste the Feeling", value: 10 },
];

////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
// FUNNEL CHART
export const FunnelChartSampleData = [
  { value: 10, label: "Impression" },
  { value: 9, label: "metrics.video_quartile_p25_rate" },
  { value: 6, label: "metrics.video_quartile_p50_rate" },
  { value: 5, label: "metrics.video_quartile_p75_rate" },
  { value: 4, label: "metrics.video_quartile_p100_rate" },
];

////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
// BUBBLE CHART
export const BubbleChartSampleData = [
  {
    Value: 0,
    children: [
      {
        label: "SIZE_1",
        value: 210,
      },
      {
        label: "SIZE_10001_OR_MORE",
        value: 3619,
      },
      {
        label: "SIZE_1001_TO_5000",
        value: 5191,
      },
      {
        label: "SIZE_11_TO_50",
        value: 2447,
      },
      {
        label: "SIZE_201_TO_500",
        value: 2604,
      },
      {
        label: "SIZE_2_TO_10",
        value: 1176,
      },
      {
        label: "SIZE_5001_TO_10000",
        value: 1205,
      },
      {
        label: "SIZE_501_TO_1000",
        value: 2156,
      },
      {
        label: "SIZE_51_TO_200",
        value: 2932,
      },
    ],
  },
];

export const ZoomableBubbleChartSampleData = [
  {
    type: "tweet",
    color: "#333333",
    impressions: 1349.69694102398,
    tweets: 60.524,
    value: 1,
  },
  {
    type: "video",
    color: "#eeeeee",
    impressions: 748.69694102398,
    tweets: 28.524,
    value: 1,
  },
  {
    type: "media",
    color: "#3hffht",
    impressions: 999.69694102398,
    tweets: 28.524,
    value: 1,
  },
  {
    type: "poll",
    color: "#000000",
    impressions: 99.69694102398,
    tweets: 28.524,
    value: 1,
  },
];

export const ZoomableBubbleChartSampleDataLabelsSample = [
  {
    value: "value",
    value1: "impressions",
    value1Label: "Impressions",
    value2: "tweets",
    value2Label: "Tweets",
  },
];

// BubbleChartSizeShapeDynamic
export const BubbleChartSizeShapeDynamicDataSample = [
  {
    "y": 7545167,
    "x": 675422,
    "value": 1341057,
    "market": "West",
    "growth": -1,
    "color": "0xb51c2a"
  }, {
    "y": 28669419,
    "x": 32811426,
    "value": 491911,
    "market": "East",
    "growth": 1,
    "color": "0x06a57d"
  }, {
    "y": 32811426,
    "x": 1170978,
    "value": 1170978,
    "market": "North",
    "growth": -1,
    "color": "0xb51c2a"
  }, {
    "y": 4495876,
    "x": 9573749,
    "value": 107634459,
    "market": "South",
    "growth": 1,
    "color": "0x06a57d"
  }
]

export const BubbleChartSizeShapeDynamicDataLabelSample = [{
  growth: "growth",
  market: "market",
  value: "value",
  valuex: "x",
  valuexLabel: "Spends",
  valuey: "y",
  valueyLabel: "Sales",
  color: "color"
}]

////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
// HEAT MAP

export const HeatMapSampleData = [
  {
    xaxis_label: "12pm",
    yaxis_label: "Sunday",
    value: 2990,
  },
  {
    xaxis_label: "1am",
    yaxis_label: "Sunday",
    value: 2520,
  },
  {
    xaxis_label: "2am",
    yaxis_label: "Sunday",
    value: 2334,
  },
  {
    xaxis_label: "3am",
    yaxis_label: "Sunday",
    value: 2230,
  },
  {
    xaxis_label: "4am",
    yaxis_label: "Sunday",
    value: 2325,
  },
  {
    xaxis_label: "5am",
    yaxis_label: "Sunday",
    value: 2019,
  },
  {
    xaxis_label: "6am",
    yaxis_label: "Sunday",
    value: 2128,
  },
  {
    xaxis_label: "7am",
    yaxis_label: "Sunday",
    value: 2246,
  },
  {
    xaxis_label: "8am",
    yaxis_label: "Sunday",
    value: 2421,
  },
  {
    xaxis_label: "9am",
    yaxis_label: "Sunday",
    value: 2788,
  },
  {
    xaxis_label: "10am",
    yaxis_label: "Sunday",
    value: 2959,
  },
  {
    xaxis_label: "11am",
    yaxis_label: "Sunday",
    value: 3018,
  },
  {
    xaxis_label: "12am",
    yaxis_label: "Sunday",
    value: 3154,
  },
  {
    xaxis_label: "1pm",
    yaxis_label: "Sunday",
    value: 3172,
  },
  {
    xaxis_label: "2pm",
    yaxis_label: "Sunday",
    value: 3368,
  },
  {
    xaxis_label: "3pm",
    yaxis_label: "Sunday",
    value: 3464,
  },
  {
    xaxis_label: "4pm",
    yaxis_label: "Sunday",
    value: 3746,
  },
  {
    xaxis_label: "5pm",
    yaxis_label: "Sunday",
    value: 3656,
  },
  {
    xaxis_label: "6pm",
    yaxis_label: "Sunday",
    value: 3336,
  },
  {
    xaxis_label: "7pm",
    yaxis_label: "Sunday",
    value: 3292,
  },
  {
    xaxis_label: "8pm",
    yaxis_label: "Sunday",
    value: 3269,
  },
  {
    xaxis_label: "9pm",
    yaxis_label: "Sunday",
    value: 3300,
  },
  {
    xaxis_label: "10pm",
    yaxis_label: "Sunday",
    value: 3403,
  },
  {
    xaxis_label: "11pm",
    yaxis_label: "Sunday",
    value: 3323,
  },
  {
    xaxis_label: "12pm",
    yaxis_label: "Monday",
    value: 3346,
  },
  {
    xaxis_label: "1am",
    yaxis_label: "Monday",
    value: 2725,
  },
  {
    xaxis_label: "2am",
    yaxis_label: "Monday",
    value: 3052,
  },
  {
    xaxis_label: "3am",
    yaxis_label: "Monday",
    value: 3876,
  },
  {
    xaxis_label: "4am",
    yaxis_label: "Monday",
    value: 4453,
  },
  {
    xaxis_label: "5am",
    yaxis_label: "Monday",
    value: 3972,
  },
  {
    xaxis_label: "6am",
    yaxis_label: "Monday",
    value: 4644,
  },
  {
    xaxis_label: "7am",
    yaxis_label: "Monday",
    value: 5715,
  },
  {
    xaxis_label: "8am",
    yaxis_label: "Monday",
    value: 7080,
  },
  {
    xaxis_label: "9am",
    yaxis_label: "Monday",
    value: 8022,
  },
  {
    xaxis_label: "10am",
    yaxis_label: "Monday",
    value: 8446,
  },
  {
    xaxis_label: "11am",
    yaxis_label: "Monday",
    value: 9313,
  },
  {
    xaxis_label: "12am",
    yaxis_label: "Monday",
    value: 9011,
  },
  {
    xaxis_label: "1pm",
    yaxis_label: "Monday",
    value: 8508,
  },
  {
    xaxis_label: "2pm",
    yaxis_label: "Monday",
    value: 8515,
  },
  {
    xaxis_label: "3pm",
    yaxis_label: "Monday",
    value: 8399,
  },
  {
    xaxis_label: "4pm",
    yaxis_label: "Monday",
    value: 8649,
  },
  {
    xaxis_label: "5pm",
    yaxis_label: "Monday",
    value: 7869,
  },
  {
    xaxis_label: "6pm",
    yaxis_label: "Monday",
    value: 6933,
  },
  {
    xaxis_label: "7pm",
    yaxis_label: "Monday",
    value: 5969,
  },
  {
    xaxis_label: "8pm",
    yaxis_label: "Monday",
    value: 5552,
  },
  {
    xaxis_label: "9pm",
    yaxis_label: "Monday",
    value: 5434,
  },
  {
    xaxis_label: "10pm",
    yaxis_label: "Monday",
    value: 5070,
  },
  {
    xaxis_label: "11pm",
    yaxis_label: "Monday",
    value: 4851,
  },
  {
    xaxis_label: "12pm",
    yaxis_label: "Tuesday",
    value: 4468,
  },
  {
    xaxis_label: "1am",
    yaxis_label: "Tuesday",
    value: 3306,
  },
  {
    xaxis_label: "2am",
    yaxis_label: "Tuesday",
    value: 3906,
  },
  {
    xaxis_label: "3am",
    yaxis_label: "Tuesday",
    value: 4413,
  },
  {
    xaxis_label: "4am",
    yaxis_label: "Tuesday",
    value: 4726,
  },
  {
    xaxis_label: "5am",
    yaxis_label: "Tuesday",
    value: 4584,
  },
  {
    xaxis_label: "6am",
    yaxis_label: "Tuesday",
    value: 5717,
  },
  {
    xaxis_label: "7am",
    yaxis_label: "Tuesday",
    value: 6504,
  },
  {
    xaxis_label: "8am",
    yaxis_label: "Tuesday",
    value: 8104,
  },
  {
    xaxis_label: "9am",
    yaxis_label: "Tuesday",
    value: 8813,
  },
  {
    xaxis_label: "10am",
    yaxis_label: "Tuesday",
    value: 9278,
  },
  {
    xaxis_label: "11am",
    yaxis_label: "Tuesday",
    value: 10425,
  },
  {
    xaxis_label: "12am",
    yaxis_label: "Tuesday",
    value: 10137,
  },
  {
    xaxis_label: "1pm",
    yaxis_label: "Tuesday",
    value: 9290,
  },
  {
    xaxis_label: "2pm",
    yaxis_label: "Tuesday",
    value: 9255,
  },
  {
    xaxis_label: "3pm",
    yaxis_label: "Tuesday",
    value: 9614,
  },
  {
    xaxis_label: "4pm",
    yaxis_label: "Tuesday",
    value: 9713,
  },
  {
    xaxis_label: "5pm",
    yaxis_label: "Tuesday",
    value: 9667,
  },
  {
    xaxis_label: "6pm",
    yaxis_label: "Tuesday",
    value: 8774,
  },
  {
    xaxis_label: "7pm",
    yaxis_label: "Tuesday",
    value: 8649,
  },
  {
    xaxis_label: "8pm",
    yaxis_label: "Tuesday",
    value: 9937,
  },
  {
    xaxis_label: "9pm",
    yaxis_label: "Tuesday",
    value: 10286,
  },
  {
    xaxis_label: "10pm",
    yaxis_label: "Tuesday",
    value: 9175,
  },
  {
    xaxis_label: "11pm",
    yaxis_label: "Tuesday",
    value: 8581,
  },
  {
    xaxis_label: "12pm",
    yaxis_label: "Wednesday",
    value: 8145,
  },
  {
    xaxis_label: "1am",
    yaxis_label: "Wednesday",
    value: 7177,
  },
  {
    xaxis_label: "2am",
    yaxis_label: "Wednesday",
    value: 5657,
  },
  {
    xaxis_label: "3am",
    yaxis_label: "Wednesday",
    value: 6802,
  },
  {
    xaxis_label: "4am",
    yaxis_label: "Wednesday",
    value: 8159,
  },
  {
    xaxis_label: "5am",
    yaxis_label: "Wednesday",
    value: 8449,
  },
  {
    xaxis_label: "6am",
    yaxis_label: "Wednesday",
    value: 9453,
  },
  {
    xaxis_label: "7am",
    yaxis_label: "Wednesday",
    value: 9947,
  },
  {
    xaxis_label: "8am",
    yaxis_label: "Wednesday",
    value: 11471,
  },
  {
    xaxis_label: "9am",
    yaxis_label: "Wednesday",
    value: 12492,
  },
  {
    xaxis_label: "10am",
    yaxis_label: "Wednesday",
    value: 9388,
  },
  {
    xaxis_label: "11am",
    yaxis_label: "Wednesday",
    value: 9928,
  },
  {
    xaxis_label: "12am",
    yaxis_label: "Wednesday",
    value: 9644,
  },
  {
    xaxis_label: "1pm",
    yaxis_label: "Wednesday",
    value: 9034,
  },
  {
    xaxis_label: "2pm",
    yaxis_label: "Wednesday",
    value: 8964,
  },
  {
    xaxis_label: "3pm",
    yaxis_label: "Wednesday",
    value: 9069,
  },
  {
    xaxis_label: "4pm",
    yaxis_label: "Wednesday",
    value: 8898,
  },
  {
    xaxis_label: "5pm",
    yaxis_label: "Wednesday",
    value: 8322,
  },
  {
    xaxis_label: "6pm",
    yaxis_label: "Wednesday",
    value: 6909,
  },
  {
    xaxis_label: "7pm",
    yaxis_label: "Wednesday",
    value: 5810,
  },
  {
    xaxis_label: "8pm",
    yaxis_label: "Wednesday",
    value: 5151,
  },
  {
    xaxis_label: "9pm",
    yaxis_label: "Wednesday",
    value: 4911,
  },
  {
    xaxis_label: "10pm",
    yaxis_label: "Wednesday",
    value: 4487,
  },
  {
    xaxis_label: "11pm",
    yaxis_label: "Wednesday",
    value: 4118,
  },
  {
    xaxis_label: "12pm",
    yaxis_label: "Thursday",
    value: 3689,
  },
  {
    xaxis_label: "1am",
    yaxis_label: "Thursday",
    value: 3081,
  },
  {
    xaxis_label: "2am",
    yaxis_label: "Thursday",
    value: 6525,
  },
  {
    xaxis_label: "3am",
    yaxis_label: "Thursday",
    value: 6228,
  },
  {
    xaxis_label: "4am",
    yaxis_label: "Thursday",
    value: 6917,
  },
  {
    xaxis_label: "5am",
    yaxis_label: "Thursday",
    value: 6568,
  },
  {
    xaxis_label: "6am",
    yaxis_label: "Thursday",
    value: 6405,
  },
  {
    xaxis_label: "7am",
    yaxis_label: "Thursday",
    value: 8106,
  },
  {
    xaxis_label: "8am",
    yaxis_label: "Thursday",
    value: 8542,
  },
  {
    xaxis_label: "9am",
    yaxis_label: "Thursday",
    value: 8501,
  },
  {
    xaxis_label: "10am",
    yaxis_label: "Thursday",
    value: 8802,
  },
  {
    xaxis_label: "11am",
    yaxis_label: "Thursday",
    value: 9420,
  },
  {
    xaxis_label: "12am",
    yaxis_label: "Thursday",
    value: 8966,
  },
  {
    xaxis_label: "1pm",
    yaxis_label: "Thursday",
    value: 8135,
  },
  {
    xaxis_label: "2pm",
    yaxis_label: "Thursday",
    value: 8224,
  },
  {
    xaxis_label: "3pm",
    yaxis_label: "Thursday",
    value: 8387,
  },
  {
    xaxis_label: "4pm",
    yaxis_label: "Thursday",
    value: 8218,
  },
  {
    xaxis_label: "5pm",
    yaxis_label: "Thursday",
    value: 7641,
  },
  {
    xaxis_label: "6pm",
    yaxis_label: "Thursday",
    value: 6469,
  },
  {
    xaxis_label: "7pm",
    yaxis_label: "Thursday",
    value: 5441,
  },
  {
    xaxis_label: "8pm",
    yaxis_label: "Thursday",
    value: 4952,
  },
  {
    xaxis_label: "9pm",
    yaxis_label: "Thursday",
    value: 4643,
  },
  {
    xaxis_label: "10pm",
    yaxis_label: "Thursday",
    value: 4393,
  },
  {
    xaxis_label: "11pm",
    yaxis_label: "Thursday",
    value: 4017,
  },
  {
    xaxis_label: "12pm",
    yaxis_label: "Friday",
    value: 4022,
  },
  {
    xaxis_label: "1am",
    yaxis_label: "Friday",
    value: 3063,
  },
  {
    xaxis_label: "2am",
    yaxis_label: "Friday",
    value: 3638,
  },
  {
    xaxis_label: "3am",
    yaxis_label: "Friday",
    value: 3968,
  },
  {
    xaxis_label: "4am",
    yaxis_label: "Friday",
    value: 4070,
  },
  {
    xaxis_label: "5am",
    yaxis_label: "Friday",
    value: 4019,
  },
  {
    xaxis_label: "6am",
    yaxis_label: "Friday",
    value: 4548,
  },
  {
    xaxis_label: "7am",
    yaxis_label: "Friday",
    value: 5465,
  },
  {
    xaxis_label: "8am",
    yaxis_label: "Friday",
    value: 6909,
  },
  {
    xaxis_label: "9am",
    yaxis_label: "Friday",
    value: 7706,
  },
  {
    xaxis_label: "10am",
    yaxis_label: "Friday",
    value: 7867,
  },
  {
    xaxis_label: "11am",
    yaxis_label: "Friday",
    value: 8615,
  },
  {
    xaxis_label: "12am",
    yaxis_label: "Friday",
    value: 8218,
  },
  {
    xaxis_label: "1pm",
    yaxis_label: "Friday",
    value: 7604,
  },
  {
    xaxis_label: "2pm",
    yaxis_label: "Friday",
    value: 7429,
  },
  {
    xaxis_label: "3pm",
    yaxis_label: "Friday",
    value: 7488,
  },
  {
    xaxis_label: "4pm",
    yaxis_label: "Friday",
    value: 7493,
  },
  {
    xaxis_label: "5pm",
    yaxis_label: "Friday",
    value: 6998,
  },
  {
    xaxis_label: "6pm",
    yaxis_label: "Friday",
    value: 5941,
  },
  {
    xaxis_label: "7pm",
    yaxis_label: "Friday",
    value: 5068,
  },
  {
    xaxis_label: "8pm",
    yaxis_label: "Friday",
    value: 4636,
  },
  {
    xaxis_label: "9pm",
    yaxis_label: "Friday",
    value: 4241,
  },
  {
    xaxis_label: "10pm",
    yaxis_label: "Friday",
    value: 3858,
  },
  {
    xaxis_label: "11pm",
    yaxis_label: "Friday",
    value: 3833,
  },
  {
    xaxis_label: "12pm",
    yaxis_label: "Saturday",
    value: 3503,
  },
  {
    xaxis_label: "1am",
    yaxis_label: "Saturday",
    value: 2842,
  },
  {
    xaxis_label: "2am",
    yaxis_label: "Saturday",
    value: 2808,
  },
  {
    xaxis_label: "3am",
    yaxis_label: "Saturday",
    value: 2399,
  },
  {
    xaxis_label: "4am",
    yaxis_label: "Saturday",
    value: 2280,
  },
  {
    xaxis_label: "5am",
    yaxis_label: "Saturday",
    value: 2139,
  },
  {
    xaxis_label: "6am",
    yaxis_label: "Saturday",
    value: 2527,
  },
  {
    xaxis_label: "7am",
    yaxis_label: "Saturday",
    value: 2940,
  },
  {
    xaxis_label: "8am",
    yaxis_label: "Saturday",
    value: 3066,
  },
  {
    xaxis_label: "9am",
    yaxis_label: "Saturday",
    value: 3494,
  },
  {
    xaxis_label: "10am",
    yaxis_label: "Saturday",
    value: 3287,
  },
  {
    xaxis_label: "11am",
    yaxis_label: "Saturday",
    value: 3416,
  },
  {
    xaxis_label: "12am",
    yaxis_label: "Saturday",
    value: 3432,
  },
  {
    xaxis_label: "1pm",
    yaxis_label: "Saturday",
    value: 3523,
  },
  {
    xaxis_label: "2pm",
    yaxis_label: "Saturday",
    value: 3542,
  },
  {
    xaxis_label: "3pm",
    yaxis_label: "Saturday",
    value: 3347,
  },
  {
    xaxis_label: "4pm",
    yaxis_label: "Saturday",
    value: 3292,
  },
  {
    xaxis_label: "5pm",
    yaxis_label: "Saturday",
    value: 3416,
  },
  {
    xaxis_label: "6pm",
    yaxis_label: "Saturday",
    value: 3131,
  },
  {
    xaxis_label: "7pm",
    yaxis_label: "Saturday",
    value: 3057,
  },
  {
    xaxis_label: "8pm",
    yaxis_label: "Saturday",
    value: 3227,
  },
  {
    xaxis_label: "9pm",
    yaxis_label: "Saturday",
    value: 3060,
  },
  {
    xaxis_label: "10pm",
    yaxis_label: "Saturday",
    value: 2855,
  },
  {
    xaxis_label: "11pm",
    yaxis_label: "Saturday",
    value: 2625,
  },
];

export const HeatMapXAxisDataLabelSample = [
  { xaxis_label: "12pm" },
  { xaxis_label: "1am" },
  { xaxis_label: "2am" },
  { xaxis_label: "3am" },
  { xaxis_label: "4am" },
  { xaxis_label: "5am" },
  { xaxis_label: "6am" },
  { xaxis_label: "7am" },
  { xaxis_label: "8am" },
  { xaxis_label: "9am" },
  { xaxis_label: "10am" },
  { xaxis_label: "11am" },
  { xaxis_label: "12am" },
  { xaxis_label: "1pm" },
  { xaxis_label: "2pm" },
  { xaxis_label: "3pm" },
  { xaxis_label: "4pm" },
  { xaxis_label: "5pm" },
  { xaxis_label: "6pm" },
  { xaxis_label: "7pm" },
  { xaxis_label: "8pm" },
  { xaxis_label: "9pm" },
  { xaxis_label: "10pm" },
  { xaxis_label: "11pm" },
];

export const HeatMapYAxisDataLabelSample = [
  { yaxis_label: "Sunday" },
  { yaxis_label: "Monday" },
  { yaxis_label: "Tuesday" },
  { yaxis_label: "Wednesday" },
  { yaxis_label: "Thursday" },
  { yaxis_label: "Friday" },
  { yaxis_label: "Saturday" },
];

export const CampaignGoogleParentPieDataSample = [
  { value: 10, label: "Google Search" },
  { value: 9, label: "Search partners." },
  { value: 6, label: "Display Network." },
  { value: 5, label: "Youtube (YouTube Search, YouTube Videos)" },
  { value: 4, label: "Five" },
  { value: 3, label: "Cross-network" },
];

export const CampaignGoogleChildPieDataSample = [
  { value: 10, label: "Display Campaign" },
  { value: 9, label: "Search campaign" },
  { value: 6, label: "Performance Max" },
  { value: 5, label: "Discovery Campaign" },
  { value: 4, label: "Video Campaign" },
  { value: 3, label: "Smart Campaign" },
  { value: 2, label: "Call Campaign" },
  { value: 1, label: "App Campaign" },
];

export const CampaignGoogleLineChartLabel = [
  {
    label: "Conversions",
    value: "value",
  },
  {
    label: "Impressions",
    value: "value2",
  },
  {
    label: "Clicks",
    value: "value3",
  },
  {
    label: "Spends",
    value: "value4",
  },

  {
    label: "Video views",
    value: "value5",
  },
  {
    label: "Leads",
    value: "value6",
  },
];

export const CampaignGoogleLineChartData = [
  {
    label: daysAgo[7],
    value1: 1587,
    value2: 1354,
    value3: 121,
    totalsoldvalue1: 785,
    totalsoldvalue2: 685,
    totalsoldvalue3: 585,
  },
  {
    label: daysAgo[6],
    value1: 1567,
    value2: 1423,
    value3: 146,
    totalsoldvalue1: 182,
    totalsoldvalue2: 282,
    totalsoldvalue3: 382,
  },
  {
    label: daysAgo[5],
    value1: 1617,
    value2: 1517,
    value3: 138,
    totalsoldvalue1: 185,
    totalsoldvalue2: 285,
    totalsoldvalue3: 385,
  },
  {
    label: daysAgo[4],
    value1: 1630,
    value2: 1530,
    value3: 127,
    totalsoldvalue1: 145,
    totalsoldvalue2: 245,
    totalsoldvalue3: 345,
  },
  {
    label: daysAgo[3],
    value1: 1660,
    value2: 1560,
    value3: 105,
    totalsoldvalue1: 145,
    totalsoldvalue2: 245,
    totalsoldvalue3: 345,
  },
  {
    label: daysAgo[2],
    value1: 1683,
    value2: 1683,
    value3: 109,
    totalsoldvalue1: 185,
    totalsoldvalue2: 285,
    totalsoldvalue3: 385,
  },
  {
    label: daysAgo[1],
    value1: 1691,
    value2: 1692,
    value3: 112,
    totalsoldvalue1: 1250,
    totalsoldvalue2: 2250,
    totalsoldvalue3: 3250,
  },
];

export const CampaignFacebookPieDataSample = [
  { value: 10, label: "Awareness" },
  { value: 9, label: "Traffic" },
  { value: 6, label: "Engagement" },
  { value: 5, label: "Leads" },
  { value: 4, label: "App promotion" },
  { value: 3, label: "Sales" },
];

export const CampaigndFacebookLineChartLabel = [
  {
    label: "Conversions",
    value: "value",
  },
  {
    label: "Impressions",
    value: "value2",
  },
  {
    label: "Clicks",
    value: "value3",
  },
  {
    label: "Spends",
    value: "value4",
  },

  {
    label: "Video views",
    value: "value5",
  },
  {
    label: "Leads",
    value: "value6",
  },
  {
    label: "app installs",
    value: "value7",
  },
  {
    label: "engagement",
    value: "value8",
  },
];


// MULTIPLE VALUE AXES LINECHART
export const MultiAxisMultiLineChartDataSample = [
  [
    {
      label: "2022-11-13",
      value: 104,
    },
    {
      label: "2022-11-14",
      value: 105,
    },
    {
      label: "2022-11-15",
      value: 107,
    },
    {
      label: "2022-11-16",
      value: 110,
    },
    {
      label: "2022-11-17",
      value: 114,
    },
    {
      label: "2022-11-18",
      value: 120,
    },
    {
      label: "2022-11-19",
      value: 116,
    },
    {
      label: "2022-11-20",
      value: 104,
    },
    {
      label: "2022-11-21",
      value: 105,
    },
    {
      label: "2022-11-22",
      value: 107,
    },
    {
      label: "2022-11-23",
      value: 110,
    },
    {
      label: "2022-11-24",
      value: 114,
    },
    {
      label: "2022-11-25",
      value: 120,
    },
    {
      label: "2022-11-26",
      value: 116,
    },
  ],
  [
    {
      label: "2022-11-13",
      value: 1016,
    },
    {
      label: "2022-11-14",
      value: 984,
    },
    {
      label: "2022-11-15",
      value: 967,
    },
    {
      label: "2022-11-16",
      value: 950,
    },
    {
      label: "2022-11-17",
      value: 956,
    },
    {
      label: "2022-11-18",
      value: 964,
    },
    {
      label: "2022-11-19",
      value: 946,
    },
  ],
];
export const MultiAxisMultiLineChartDataLabelsSample = [
  {
    label: "LabelA",
    value: "value",
    opposite: false,
  },
  {
    label: "LabelB",
    value: "value",
    opposite: true,
  }

];


export const StackedClusteredBarChartData = [{
  "label": "2022-11-16",
  "tv_spends": 2.5,
  "digital_meta_spends": 2.5,
  "digital_dv_spends": 2.1,
  "tv_impression": 1,
  "digital_meta_imp": 0.8,
  "digital_dv_imp": 0.4,
  "monthly_Sales": 12
}, {
  "label": "2022-11-18",
  "tv_spends": 2.6,
  "digital_meta_spends": 2.7,
  "digital_dv_spends": 2.2,
  "tv_impression": 0.5,
  "digital_meta_imp": 0.4,
  "digital_dv_imp": 0.3,
  "monthly_Sales": 12

}, {
  "label": "2022-11-19",
  "tv_spends": 2.8,
  "digital_meta_spends": 2.9,
  "digital_dv_spends": 2.4,
  "tv_impression": 0.3,
  "digital_meta_imp": 0.9,
  "digital_dv_imp": 0.5,
  "monthly_Sales": 12
}];

export const StackedClusteredBarChartLabels = [
  {
    "linechartLabels": [
      {
        label: "Monthly Sales Vol.",
        value: "monthly_Sales",
      },
    ],
    "barchartLabels": [
      {
        label: "TV spends %",
        value: "tv_spends",
        stackable: false
      },
      {
        label: "Digital Meta spends %",
        value: "digital_meta_spends",
        stackable: true

      },
      {
        label: "Digital DV360 Spends%",
        value: "digital_dv_spends"
        , stackable: false

      },
      {
        label: "TV Impressions %",
        value: "tv_impression"
        , stackable: true

      },
      {
        label: "Digital Meta Impressions %",
        value: "digital_meta_imp"
        , stackable: true

      },
      {
        label: "Digital DV360 Impressions %",
        value: "digital_dv_imp"
        , stackable: true
      },

    ]

  }
]



